"use client"
import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from "@/components/ui/card"
import {
    Field,
    FieldDescription,
    FieldGroup,
    FieldLabel,
} from "@/components/ui/field"
import { Input } from "@/components/ui/input"
import {FormEvent, useState} from "react";

export function LoginForm({
                              className,
                              ...props
                          }: React.ComponentProps<"div">) {
    const [error, setError] = useState("");
    const [isPending, setIsPending] = useState(false);

    async function handleSubmit(event: FormEvent<HTMLFormElement>) {
        event.preventDefault();
        setError("");
        setIsPending(true);
        const formData = new FormData(event.currentTarget);

        try {
            const response = await fetch("/api/auth/login", {
                method: "POST",
                credentials: "include",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    username: formData.get("username"),
                    password: formData.get("password"),
                }),
            });
            const result = await response.json();
            if (!response.ok || !result?.ok) {
                throw new Error(result?.message || "账号或密码错误");
            }
            window.location.href = result?.data?.role === "admin" ? "/admin/gameItem" : "/main";
        } catch (loginError) {
            setError(loginError instanceof Error ? loginError.message : "登录失败");
        } finally {
            setIsPending(false);
        }
    }
    return (
        <div className={cn("flex flex-col gap-6", className)} {...props}>
            <Card>
                <CardHeader>
                    <CardTitle>登录账号</CardTitle>
                    <CardDescription>
                        请输入你的游戏账号
                    </CardDescription>
                </CardHeader>
                <CardContent>
                    <form onSubmit={handleSubmit}>
                        <FieldGroup>
                            <Field>
                                <FieldLabel htmlFor="username">账号</FieldLabel>
                                <Input
                                    id="username"
                                    type="username"
                                    name="username"
                                    placeholder=""
                                    required
                                />
                            </Field>
                            <Field>
                                <div className="flex items-center">
                                    <FieldLabel htmlFor="password">密码</FieldLabel>
                                    <a
                                        href="#"
                                        className="ml-auto inline-block text-sm underline-offset-4 hover:underline"
                                    >
                                        忘记密码?
                                    </a>
                                </div>
                                <Input id="password" name="password" type="password" required />
                            </Field>
                            {error && <p className="text-red-500 text-center text-sm">{error}</p>}
                            <Field>
                                <Button disabled={isPending} type="submit">登录</Button>
                                <FieldDescription className="text-center">
                                    没有账号? <a href="/signup">前往注册</a>
                                </FieldDescription>
                            </Field>
                        </FieldGroup>
                    </form>
                </CardContent>
            </Card>
        </div>
    )
}
